import styled from 'styled-components';
import CoupleFriendlyIconSvg from '../assets/hotels/amenities/couple-friendly.svg';

const CoupleFriendlyIcon = styled(CoupleFriendlyIconSvg as JSX.Element)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props =>
    props.fill ||
    (props.isActive ? props.theme.colors.goBrandOrange.base : props.theme.colors.downriver.medium)};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CoupleFriendlyIcon;
